import Styles from './FillColor.module.scss'
import { GradientColor } from '../VisualEditor/Types'
import { Button } from 'blaze-ui/Button'
import { SolidFill } from './SolidFill'

interface GradientStopPickerProps {
  gradientValue: GradientColor
  editingStopIndex: number
  onChange: (newValue: Partial<GradientColor>) => any
  onDone: () => any
}

export const GradientStopPicker = ({ gradientValue, editingStopIndex, onChange, onDone }: GradientStopPickerProps) => {
  return (
    <>
      <SolidFill
        value={{
          type: 'solidColor',
          color: gradientValue.stops[editingStopIndex].color,
          opacity: gradientValue.stops[editingStopIndex].opacity,
        }}
        onChange={(color) =>
          onChange({
            stops: gradientValue.stops.map((s, i) =>
              i === editingStopIndex ? { ...s, color: color.color, opacity: color.opacity } : s,
            ),
          })
        }
        allowTransparency
      />
      <div className={Styles.footer}>
        <Button
          size="sm"
          variant="tertiary"
          isDisabled={gradientValue.stops.length <= 2}
          onPress={() => {
            onChange({
              stops: gradientValue.stops.filter((_, i) => i !== editingStopIndex),
            })
          }}
        >
          Delete
        </Button>
        <Button size="sm" variant="primary" onPress={onDone}>
          Done
        </Button>
      </div>
    </>
  )
}
